import { Flex } from '@chakra-ui/react';
import ReviewSubmissionForm from 'src/components/PeerReview/ReviewSubmissionForm';
import { ReviewedPage } from 'src/components/PeerReview/Reviewed';
import NoReviewsFound from '../ReviewList/EmptyState';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import RevisionReviewSubmissionForm from '../../components/PeerReview/RevisionReviewSubmissionForm';
import { RevisionReviewedPage } from '../../components/PeerReview/RevisionReviewed';
import { IPeerReviewWFState } from '@publishing-engine/domain/types/workflow-phases';

interface Props {
  reviewFormTrigger: boolean;
}

const DefaultComponent = () => (
  <Flex
    justifyContent="center"
    alignItems="center"
    height="100%"
    padding={2}
    bgColor="surfaceSecondaryFill"
  >
    <NoReviewsFound />
  </Flex>
);

export const ReviewTab = ({ reviewFormTrigger }: Props) => {
  const { review } = useReviewData();

  const { workflow } = review;
  const { currentState, previousState } = workflow;

  const hasSubmittedRevision = !!review.caseData.revisionAssessment;
  const rescindedRevisionResubmit =
    previousState === 'submittedRevisionAssessment';

  const reviewByState: Record<
    IPeerReviewWFState,
    React.FC<{ submitTrigger?: boolean }>
  > = {
    inReview: ReviewSubmissionForm,
    firstAssessment: ReviewSubmissionForm,
    revisionAssessment: RevisionReviewSubmissionForm,
    submittedFirstAssessment: ReviewedPage,
    submittedRevisionAssessment: RevisionReviewedPage,
    reviewed: hasSubmittedRevision ? RevisionReviewedPage : ReviewedPage,
    rescinded: rescindedRevisionResubmit
      ? RevisionReviewSubmissionForm
      : ReviewSubmissionForm,
    removed: hasSubmittedRevision ? RevisionReviewedPage : ReviewedPage,
    awaitingRevision: hasSubmittedRevision
      ? RevisionReviewedPage
      : ReviewedPage,
    awaitingRevisionReviewRequest: hasSubmittedRevision
      ? RevisionReviewedPage
      : ReviewedPage,
    invited: DefaultComponent,
    revisionInvited: DefaultComponent,
    declined: DefaultComponent,
    expired: DefaultComponent,
    closed: DefaultComponent,
    withdrawn: DefaultComponent
  };

  const ReviewComponent =
    reviewByState[currentState as keyof typeof reviewByState] ??
    DefaultComponent;

  return (
    <Flex flexDirection="column" gap={8} paddingBottom={24}>
      <ReviewComponent submitTrigger={reviewFormTrigger} />
    </Flex>
  );
};
